module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/edge_icon-828ed918925917db4947d75c712cc068.svg";